<template>
  <van-swipe :autoplay="5000" @change="onChange" class="tutor-container">
    <van-swipe-item v-for="(image, index) in images" :key="index">
      <img v-lazy="image" class="tutor-img"/>
    </van-swipe-item>
  </van-swipe>
</template>

<script>
import { Swipe, SwipeItem, Toast } from "vant";

export default {
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Toast.name]: Toast
  },
  data() {
    let imgs = [];
    for (let i = 1; i <= 6; i++) {
      imgs.push("/img/" + i + ".jpg");
    }
    return { images: imgs };
  },
  methods: {
    onChange(index) {
      switch (index) {
        case 0:
          Toast("【重要】置顶公众号，方便使用时快速找到");
          break;
        case 1:
          Toast("第1.1步 商品页点击分享");
          break;
        case 2:
          Toast("第1.2步 选择复制链接或者微信");
          break;
        case 3:
          Toast("第2.1步 打开公众号，粘贴并发送");
          break;
        case 4:
          Toast("第2.2步 复制查找到的淘口令");
          break;
        case 5:
          Toast("第2.3步 回到淘宝，打开并购买");
          break;
      }
    }
  },
  mounted() {
    Toast("【重要】置顶公众号，方便使用时快速找到");
  }
};
</script>

<style lang="less">
.tutor {
  &-container {
    box-shadow: #aaa 1px 1px 3px 0px;
    border: 1px solid #aaa;
    border-radius: 10px;
    margin: 2rem;
  }
  &-img {
    width: 100%;
    height: auto;
  }
}
</style>
